import { ParamIds, Places } from 'src/Constants'
import { RegraFormKeys } from '../regra_form.keys'

export class CondicaoFormKeys extends RegraFormKeys {
    get place() {
        return Places.mcCondicaoForm
    }

    get condicaoId() {
        return this._intent.getParameterAsNumber(ParamIds.mcCondicaoFormId)
    }

    set condicaoId(value: number | undefined) {
        this._intent.setParameter(ParamIds.mcCondicaoFormId, value)
    }
}

export default CondicaoFormKeys
